export function removeDuplicates(list) {
const seen = new Set();
return list.filter(item => {
    const key = item.id ?? item.componentName;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
});
}

export function removeCrossDuplicates(sideBar, sideBarRight) {

    const getKey = w => w.id ?? w.componentName;

    const leftKeys = new Set(sideBar.map(getKey));
    const rightKeys = new Set(sideBarRight.map(getKey));

    // detectar duplicados cruzados
    const duplicates = new Set(
        [...leftKeys].filter(k => rightKeys.has(k))
    );

    if (duplicates.size === 0) {
        return {
            sideBar,
            sideBarRight
        };
    }

    const RIGHT_ONLY = new Set([
        'user_alarms',
        'in_review_alarms',
        'in_maintenance_alarms',
        1,
        2
    ]);

    const all = [...sideBar, ...sideBarRight];

    const unique = new Map();
    for (const w of all) {
        const key = getKey(w);
        if (!unique.has(key)) unique.set(key, w);
    }

    const finalLeft = [];
    const finalRight = [];

    for (const widget of unique.values()) {
        const id = getKey(widget);

        if (RIGHT_ONLY.has(id))
            finalRight.push(widget);
        else
            finalLeft.push(widget);
    }

    return {
        sideBar: finalLeft,
        sideBarRight: finalRight
    };
}

export function forceCollapsibleAndLog(items) {
return items.map(item => {
    if (item.id === 1 || item.id === 2 || item.id === 10) {
    // console.log(`Forzando collapsible=true para item id ${item.id}`);
    return { ...item, collapsible: true };
    }
    // console.log(`Item id ${item.id} no requiere cambio`);
    return item;
});
}

export function mergeMissingWidgets(userList = [], defaultList = []) {
const userIds = userList.map(w => w.id);

const missing = defaultList.filter(
    def => !userIds.includes(def.id)
);

return [...userList, ...missing];
}
